/** Asks the QuantisAI panel to open on its Bots view from anywhere in the app.
 * The panel may not be mounted yet when it is asked (it mounts once shown),
 * so the request is also held until the panel takes it. */
export const SI_OPEN_BOTS_EVENT = 'si:open-bots';

let pending = false;

export function requestBotsView() {
  pending = true;
  window.dispatchEvent(new Event(SI_OPEN_BOTS_EVENT));
}

/** True once per request: the panel calls it at mount and on the event. */
export function takeBotsRequest(): boolean {
  const asked = pending;
  pending = false;
  return asked;
}
